import '@fancyapps/fancybox'

document.addEventListener('turbolinks:load', () => {
  $('[data-fancybox=""]').fancybox()
})